import React from 'react';

import AggregateShellComponent from "core/gd-modules/common/aggregate/aggregate-shell";

export default function AggregateTotalComponent(options, props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const value = isValid ? gd.utils.floorToDecimals(props.value, 0) : null;

    let noDataLabel;
    switch (props.aggregateFunction) {
        case gd.const.aggregate.type.SUM:   noDataLabel = '0'; break;
        default:                            noDataLabel = gd.const.aggregate.label[props.aggregateFunction]; break;
    }

    return (
        <AggregateShellComponent className="aggregate-total" options={options} noData={!isValid} hint={value} {...props}>
            {isValid &&
            <React.Fragment>
                <div className="aggregate-label">{gd.const.aggregate.label[props.aggregateFunction]}:</div>
                <div className="aggregate-value aggregate-number">{value}</div>
            </React.Fragment>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{noDataLabel}</div>}
        </AggregateShellComponent>
    );
}